// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AuditLogSummary, IAuditLogSummary } from "./AuditLogs.AuditLogSummary.gen";

export interface IAuditLogResult {
	data: IAuditLogSummary[] | undefined;

	hasMore: boolean;

	nextCursor: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class AuditLogResult {
	constructor(data?: IAuditLogResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new AuditLogSummary(d)) : [];
	}

	data: AuditLogSummary[] | undefined = [];

	hasMore: boolean = false;

	nextCursor: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.Pagination.AuditLogResult, ";
	$type?: string | undefined = AuditLogResult.$type;
}

